import fetch from "../utils/fetch";

export function verifyAltcha(data) {
  return fetch({
    url: '/api/user/altcha/verify',
    method: 'post',
    data
  });
}

export function altchaStatus(data) {
  return fetch({
    url: '/api/user/altcha/status',
    method: 'post',
    data
  });
}
